import { type IContent } from "@kunduz/data-access-cms-api";
import React, { ReactElement } from "react";
import { useAppContext } from "@kunduz/feature-website-context";
import { CmsMobileNavItems } from "./cmsMobileNavItems";
import { blue, green } from "@kunduz/ui-components";

export const MobileRight = (props: Props): ReactElement => {
  const { kunduzApiToken } = useAppContext();

  const iconColors = {
    student: blue[600],
    teacher: green[600],
    school: blue[600],
  };

  const filteredMobileCtaItems = props.mobileRightCmsData?.filter((x) => {
    if (kunduzApiToken) return !x.data.hide_for_authenticated_user;
    else return !x.data.hide_for_unauthenticated_user;
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "0px",
        gap: "12px",
        userSelect: "none",
      }}
    >
      <CmsMobileNavItems
        iconColor={iconColors[props.headerType]}
        cmsData={filteredMobileCtaItems}
        lang={props.lang}
      />
    </div>
  );
};

interface Props {
  headerType: "student" | "teacher" | "school";
  mobileRightCmsData?: IContent.HeaderItemsResponse["components"];
  lang: "tr" | "en";
}
